import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { withRouter } from 'react-router-dom';
import './styles/nav.css';

function Nav() {
	return (
		<div className="navbar">
			<ul>
				{/* Hero Link */}
				<li>
					<HashLink smooth to="/#Hero">
						Thumbs
					</HashLink>
				</li>
				{/* How It works Link */}
				<li>
					<HashLink smooth to="/#HowItWorks">
						How it works
					</HashLink>
				</li>

				{/* Install Link */}
				<li>Install Now</li>
			</ul>
		</div>
	);
}

export default withRouter(Nav);
